import React, { createContext, useContext, useState, useEffect } from 'react';
import api from './services/api';
import { normalizeBrandingConfig } from './utils/brandingUtils';

const BrandingConfigContext = createContext();

export function BrandingConfigProvider({ children }) {
  const [brandingConfig, setBrandingConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchConfig() {
      setLoading(true);
      try {
        const response = await api.getBrandingConfig();
        setBrandingConfig(
          normalizeBrandingConfig({
            ...response.config,
            font_weights: response.config?.font_weights ||
              response.config?.fontWeights || ['400', '500', '600', '700'],
          }),
        );
        setError(null);
      } catch (err) {
        setError('Failed to load branding configuration');
        setBrandingConfig(normalizeBrandingConfig(null));
      } finally {
        setLoading(false);
      }
    }
    fetchConfig();
  }, []);

  // CSS variables are applied by DesignThemeProvider (legacy + corridor themes).

  // Optionally: function to refresh config after admin update
  const refreshBrandingConfig = async () => {
    setLoading(true);
    try {
      const response = await api.getBrandingConfig();
      setBrandingConfig(
        normalizeBrandingConfig({
          ...response.config,
          font_weights: response.config?.font_weights ||
            response.config?.fontWeights || ['400', '500', '600', '700'],
        }),
      );
      setError(null);
    } catch (err) {
      setError('Failed to reload branding configuration');
      setBrandingConfig(normalizeBrandingConfig(null));
    } finally {
      setLoading(false);
    }
  };

  return (
    <BrandingConfigContext.Provider
      value={{ brandingConfig, setBrandingConfig, loading, error, refreshBrandingConfig }}
    >
      {children}
    </BrandingConfigContext.Provider>
  );
}

export function useBrandingConfig() {
  return useContext(BrandingConfigContext);
}
